import React from 'react'
import './StoryReel.css'
import Story from './Story';
function StoryReel() {
  return (
    <div className="storyReel">
      <Story
      image="https://scontent.fpat3-1.fna.fbcdn.net/v/t31.0-8/13926028_129531297488522_8330585462737784032_o.jpg?_nc_cat=109&_nc_sid=8bfeb9&_nc_ohc=cLqSi7Lo4gkAX8bUq2C&_nc_ht=scontent.fpat3-1.fna&oh=c7811dd2a684423ba57a9baf9e05fae4&oe=5F6CC5CE"
      profileSrc="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/81686253_795738660867779_3334955316939849728_o.jpg?_nc_cat=100&_nc_sid=09cbfe&_nc_ohc=L25LmxRO8_4AX_MLux8&_nc_oc=AQm8ude7VCoGUijUZ3d1oLOmFcFqCt0Kfklr8KmFTEYzfqTcFTipMTpyqO9efitRCi7T13MfES9uNWRnqLlUkt3F&_nc_ht=scontent.fpat3-1.fna&oh=f3e54e421eaa4815d0188ef7973b2aac&oe=5F6DCBC4"
      title="Vikash Kumar Srivastav"
      />

<Story
      image="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/10615447_1544018879165188_4571815003864110073_n.jpg?_nc_cat=103&_nc_sid=ba80b0&_nc_ohc=apoUWJdoLJIAX_EQxkm&_nc_ht=scontent.fpat3-1.fna&oh=092f9314257b45a0396dc84f6bdf279c&oe=5F6E8FCD"
      profileSrc="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/15442217_1879812428919163_987199653534495374_n.jpg?_nc_cat=104&_nc_sid=09cbfe&_nc_ohc=WBdUM2sJqsUAX-dLO7O&_nc_ht=scontent.fpat3-1.fna&oh=16c8ce9681db052ebe3f39d632dbf7fd&oe=5F6E4E67"
      title="Deepesh Twister"
      />


<Story
      image="https://scontent.fpat3-1.fna.fbcdn.net/v/t31.0-8/1417778_218642008320549_2129014457_o.jpg?_nc_cat=103&_nc_sid=ba80b0&_nc_ohc=VJ3JNvCKvO0AX_ACprH&_nc_ht=scontent.fpat3-1.fna&oh=e0ded135b89cd3b7fc2e5700dfe7cb29&oe=5F6D222D"
      profileSrc="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/1236495_176588522525898_134788684_n.jpg?_nc_cat=105&_nc_sid=09cbfe&_nc_ohc=yJCQ4MPksgsAX-UnJwi&_nc_ht=scontent.fpat3-1.fna&oh=1eb2f887dbae3d8bfd1ef632fec528c7&oe=5F6D477D"
      title="Shashi Ranjan"
      />


<Story
      image="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/555507_314483105344103_1090280018_n.jpg?_nc_cat=104&_nc_sid=174925&_nc_ohc=kSlgBnPCfQQAX_ES6Ve&_nc_ht=scontent.fpat3-1.fna&oh=abbe95668bfe60b99caf9b5a9fdbc41a&oe=5F70033A"
      profileSrc="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/18921642_1219359518189786_267614507501903349_n.jpg?_nc_cat=111&_nc_sid=09cbfe&_nc_ohc=JRgoRes1ZrkAX-qpECo&_nc_ht=scontent.fpat3-1.fna&oh=6b6e9ead7b4a26203ae89110d70d2c32&oe=5F7017C8"
      title="Parag Thakur"
      />

<Story
      image="https://scontent.fpat3-1.fna.fbcdn.net/v/t1.0-9/428328_241190015956910_575727313_n.jpg?_nc_cat=109&_nc_sid=de6eea&_nc_ohc=P1zZiOx4_UwAX8AYmMh&_nc_ht=scontent.fpat3-1.fna&oh=6ab30eaccd0941a8e47c9980e8eba719&oe=5F6CB975"
      profileSrc="https://scontent.fpat3-1.fna.fbcdn.net/v/t31.0-8/27022088_1538819349527297_2273272936918929543_o.jpg?_nc_cat=108&_nc_sid=09cbfe&_nc_ohc=MIq3D9lQXnYAX-gZ3Zq&_nc_ht=scontent.fpat3-1.fna&oh=afda96ecec2ca7442247960e838d5e73&oe=5F6F2277"
      title="Vishal Kumar"
      />
      
    </div>
  )
}

export default StoryReel
